// console.log()
$(document).ready(function() {
  const urlParams = new URLSearchParams(document.location.search);

  if(!urlParams.has('feedback') || urlParams.get('feedback') != 'true') {
    return;
  }

  const shareButton = document.querySelector('share-button');

  if(!shareButton) {
    return;
  }

  setTimeout(function() {
    if(!urlParams.has('feedback') || urlParams.get('feedback') != 'true') {
      return;
    }

    shareButton.scrollIntoView();

    const isElementLoaded = async selector => {
      while (!document.querySelectorAll(selector)?.length) {
        await new Promise(resolve => requestAnimationFrame(resolve))
      } 

      return document.querySelector(selector);
    };

    // I'm checking for a specific class and then running code. You can also check for an id or an element.
    isElementLoaded('.r--text-btn-write, .r--text-write').then((selector) => {
      const cta = document.querySelector('ryviu-widget[vce-ready] .r--text-btn-write') || document.querySelector('ryviu-widget[vce-ready] .r--text-write') || null;

      if(cta) {
        cta.click();
      }
    });    
  }, 1500);
});